export default "__VITE_ASSET__bReVA$RR__"